<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 shadow-none">
        <div class="card-body p-3">
          <!-- Header -->
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4">
            <div>
              <h1 class="card-title mb-1">Inventory</h1>
              <span class="sub-text">Track factory stock, finished goods, transfers and stock adjustments.</span>
            </div>
          </div>

          <!-- Tabs -->
          <ul class="nav nav-pills mb-4" role="tablist">
            @for (tab of tabs; track tab.value) {
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  [ngClass]="{ active: selectedTab === tab.value }"
                  (click)="selectTab(tab.value)">
                  <i [class]="tab.icon"></i>
                  <span class="ms-2">{{ tab.label }}</span>
                </button>
              </li>
            }
          </ul>

          @if (isLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            <ng-container [ngSwitch]="selectedTab">
              <ng-container *ngSwitchCase="InventoryTab.FACTORY_STOCK">
                <app-factory-stock [factoryList]="factories" />
              </ng-container>

              <ng-container *ngSwitchCase="InventoryTab.FINISH_GOODS_STOCK">
                <app-production-stock />
              </ng-container>

              <ng-container *ngSwitchCase="InventoryTab.TRANSFERS">
                <app-product-transfer [factoryList]="factories" />
              </ng-container>

              <ng-container *ngSwitchCase="InventoryTab.FACTORY_STOCK_ADJUSTMENTS">
                <app-product-stock-adjustments scope="factory" [factoryList]="factories" />
              </ng-container>

              <ng-container *ngSwitchCase="InventoryTab.WAREHOUSE_STOCK_ADJUSTMENTS">
                <app-product-stock-adjustments scope="warehouse" />
              </ng-container>
            </ng-container>
          }
        </div>
      </div>
    </div>
  </div>
</div>
